import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g className="stroke-change" fill="none" fillRule="evenodd" stroke="#9F9F9F" strokeWidth="3">
      <path d="M9.5 21.5V37a1.5 1.5 0 0 0 1.5 1.5h26a1.5 1.5 0 0 0 1.5-1.5V21.5h-29zM9.328 19.965L8.2 13.563a.5.5 0 0 1 .406-.579L36.18 8.122a.5.5 0 0 1 .579.406l1.128 6.4-28.559 5.037z" />
      <path
        strokeLinejoin="round"
        d="M13.673 18.69l2.724-7.587M21.551 17.302l2.724-7.589M29.43 15.913l2.723-7.589"
      />
    </g>
  </svg>
);
